import { LuBuilding2 } from "react-icons/lu";
import { MdAdd, MdOutlineDashboard } from "react-icons/md";
import BreadCrumbs from "../../components/AdminC/Breadcrumb";

const AdminAddCompany = () => {
  const breadcrumbsData = [
    {
      text: "Dashboard",
      href: "/adminDashboard",
      icon: <MdOutlineDashboard />,
    },
    {
      text: "Company Detail",
      href: "/adminDashboard/companies",
      icon: <LuBuilding2 />,
    },
    {
      text: "Add Company Detail",
      href: "/adminDashboard/companies/add-new-company",
      icon: <MdAdd />,
    },
  ];
  return (
    <div className=" px-3 px-sm-5 pt-2 pt-sm-3">
      <BreadCrumbs breadcrumbs={breadcrumbsData} />
      <div className="w-100 rounded-2 bg-white border company-container mt-4">
        <h2 className="addCompany-title heading-text">
          Add Company Detail Page
        </h2>
        <div className="">
          <form className="addCompany">
            <div className="row g-4">
              {/* Publically Known As */}
              <div className="col-md-6 ">
                <label
                  htmlFor="publiclyKnownAs"
                  className="form-label label-text"
                >
                  Publically Known As <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control addCompany-input"
                  id="publiclyKnownAs"
                  placeholder="Enter Publically Known As"
                />
              </div>

              {/* Company URL */}
              <div className="col-md-6">
                <label htmlFor="companyUrl" className="form-label label-text">
                  Company url
                </label>
                <input
                  type="text"
                  className="form-control addCompany-input"
                  id="companyUrl"
                  placeholder="Enter Company url"
                />
              </div>

              {/* Parent Company Name */}
              <div className="col-md-6">
                <label
                  htmlFor="parentCompanyName"
                  className="form-label label-text"
                >
                  Parent company name
                </label>
                <input
                  type="text"
                  className="form-control addCompany-input"
                  id="parentCompanyName"
                  placeholder="Enter Parent company name"
                />
              </div>

              {/* Parent Company URL */}
              <div className="col-md-6">
                <label
                  htmlFor="parentCompanyUrl"
                  className="form-label label-text"
                >
                  Parent company url
                </label>
                <input
                  type="text"
                  className="form-control addCompany-input"
                  id="parentCompanyUrl"
                  placeholder="Enter Parent company url"
                />
              </div>

              {/* About */}
              <div className="col-12">
                <label htmlFor="about" className="form-label label-text">
                  About
                </label>
                <textarea
                  className="form-control addCompany-input "
                  id="about"
                  rows="2"
                  placeholder="Enter About the company"
                  style={{ height: "auto" }}
                ></textarea>
              </div>

              {/* Logo */}
              <div className="col-md-6">
                <label htmlFor="logo" className="form-label label-text">
                  Logo
                </label>
                <input
                  type="file"
                  className="form-control addCompany-input"
                  id="logo"
                />
              </div>

              {/* Company Office Countries */}
              <div className="col-md-6">
                <label
                  htmlFor="officeCountries"
                  className="form-label label-text"
                >
                  Company office countries
                </label>
                <select
                  id="officeCountries"
                  className="form-select addCompany-input"
                >
                  {/* <option selected disabled value="">
                    None Selected
                  </option> */}
                  <option value="USA">United States</option>
                  <option value="CAN">Canada</option>
                  <option value="UK">United Kingdom</option>
                  <option value="IND">India</option>
                </select>
              </div>

              {/* CEO */}
              <div className="col-md-6">
                <label htmlFor="ceo" className="form-label label-text">
                  CEO
                </label>
                <input
                  type="text"
                  className="form-control addCompany-input"
                  id="ceo"
                  placeholder="Enter CEO"
                />
              </div>

              {/* CEO Linkedin Profile */}
              <div className="col-md-6">
                <label htmlFor="ceoLinkedin" className="form-label label-text">
                  CEO Linkedin profile
                </label>
                <input
                  type="text"
                  className="form-control addCompany-input"
                  id="ceoLinkedin"
                  placeholder="CEO Linkedin profile"
                />
              </div>

              {/* Headquarter Section START */}
              <div className="col-12">
                <div className="form-section__title">
                  <h2>Headquarter</h2>
                </div>
                <fieldset className="form-section">
                  <div className="form-section__body">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label
                          htmlFor="hqCountry"
                          className="form-label label-text"
                        >
                          Country
                        </label>
                        <select
                          id="hqCountry"
                          className="form-select addCompany-input"
                        >
                          <option value="">Choose Country</option>
                          {/* TODO: map countries from API */}
                          <option value="India">India</option>
                          <option value="United States">United States</option>
                          <option value="United Kingdom">United Kingdom</option>
                          <option value="Canada">Canada</option>
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="hqCity"
                          className="form-label label-text"
                        >
                          City
                        </label>
                        <input
                          type="text"
                          id="hqCity"
                          className="form-control addCompany-input"
                          placeholder="Enter City"
                        />
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="hqPhone"
                          className="form-label label-text"
                        >
                          Phone
                        </label>
                        <input
                          type="tel"
                          id="hqPhone"
                          className="form-control addCompany-input"
                          placeholder="Enter Phone No."
                        />
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="hqEmail"
                          className="form-label label-text"
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          id="hqEmail"
                          className="form-control addCompany-input"
                          placeholder="Enter Email"
                        />
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="hqPostal"
                          className="form-label label-text"
                        >
                          Postal Code
                        </label>
                        <input
                          type="text"
                          id="hqPostal"
                          className="form-control addCompany-input"
                          placeholder="Enter Postal Code"
                        />
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              {/* Headquarter Section END */}
              {/* Firmographics Section START */}
              <div className="col-12">
                <fieldset className="form-section">
                  <div className="form-section__title">
                    <h2 className="company-heading m-0">Firmographics</h2>
                  </div>

                  <div className="form-section__body">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label
                          htmlFor="yearEstablishment"
                          className="form-label label-text"
                        >
                          Year of establishment
                        </label>
                        <select
                          id="yearEstablishment"
                          className="form-select addCompany-input"
                          defaultValue=""
                        >
                          <option value="" disabled>
                            Choose
                          </option>
                          {/* TODO: map years */}
                          <option>2025</option>
                          <option>2024</option>
                          <option>2023</option>
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="sectorIndustry"
                          className="form-label label-text"
                        >
                          Sector/Industry
                        </label>
                        <select
                          id="sectorIndustry"
                          className="form-select addCompany-input"
                          defaultValue=""
                        >
                          <option value="" disabled>
                            Choose
                          </option>
                          {/* TODO: map sectors/industries */}
                          <option>Information Technology</option>
                          <option>Healthcare</option>
                          <option>Finance</option>
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="employeeSize"
                          className="form-label label-text"
                        >
                          Employee Size
                        </label>
                        <select
                          id="employeeSize"
                          className="form-select addCompany-input"
                          defaultValue=""
                        >
                          <option value="" disabled>
                            Choose
                          </option>
                          {/* TODO: map sizes */}
                          <option>1-10</option>
                          <option>11-50</option>
                          <option>51-200</option>
                          <option>201-500</option>
                          <option>500+</option>
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="companyType"
                          className="form-label label-text"
                        >
                          Company type
                        </label>
                        <select
                          id="companyType"
                          className="form-select addCompany-input"
                          defaultValue=""
                        >
                          <option value="" disabled>
                            Choose
                          </option>
                          {/* TODO: map types */}
                          <option>Public</option>
                          <option>Private</option>
                          <option>Non-profit</option>
                          <option>Government</option>
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="businessModel"
                          className="form-label label-text"
                        >
                          Business Model
                        </label>
                        <select
                          id="businessModel"
                          className="form-select addCompany-input"
                          defaultValue=""
                        >
                          <option value="" disabled>
                            None Selected
                          </option>
                          {/* TODO: map models */}
                          <option>B2B</option>
                          <option>B2C</option>
                          <option>B2B2C</option>
                          <option>Marketplace</option>
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="estimatedRevenue"
                          className="form-label label-text"
                        >
                          Estimated Annual Revenue
                        </label>
                        <select
                          id="estimatedRevenue"
                          className="form-select addCompany-input"
                          defaultValue=""
                        >
                          <option value="" disabled>
                            Choose
                          </option>
                          {/* TODO: map revenue ranges */}
                          <option>$0 - $1M</option>
                          <option>$1M - $10M</option>
                          <option>$10M - $100M</option>
                          <option>$100M+</option>
                        </select>
                      </div>

                      <div className="col-12">
                        <label
                          htmlFor="fundingRaised"
                          className="form-label label-text"
                        >
                          Funding Raised
                        </label>
                        <input
                          type="text"
                          id="fundingRaised"
                          className="form-control addCompany-input"
                          placeholder="Enter Funding Raised"
                        />
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              {/* Firmographics Section END */}
              {/* Social/Other Section START */}
              <div className="col-12">
                <fieldset className="form-section">
                  <div className="form-section__title">
                    <h2 className="company-heading m-0">Social/Other</h2>
                  </div>

                  <div className="form-section__body">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label
                          htmlFor="linkedInUrl"
                          className="form-label label-text"
                        >
                          LinkedIn URL
                        </label>
                        <input
                          type="url"
                          id="linkedInUrl"
                          className="form-control addCompany-input"
                          placeholder="Enter LinkedIn URL"
                        />
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="twitterUrl"
                          className="form-label label-text"
                        >
                          Twitter URL
                        </label>
                        <input
                          type="url"
                          id="twitterUrl"
                          className="form-control addCompany-input"
                          placeholder="Enter Twitter URL"
                        />
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="instaUrl"
                          className="form-label label-text"
                        >
                          Insta URL
                        </label>
                        <input
                          type="url"
                          id="instaUrl"
                          className="form-control addCompany-input"
                          placeholder="Enter Insta URL"
                        />
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="sicCode"
                          className="form-label label-text"
                        >
                          SIC Code
                        </label>
                        <input
                          type="text"
                          id="sicCode"
                          className="form-control addCompany-input"
                          placeholder="Enter SIC Code"
                        />
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="naicsCode"
                          className="form-label label-text"
                        >
                          NAICS Code
                        </label>
                        <input
                          type="text"
                          id="naicsCode"
                          className="form-control addCompany-input"
                          placeholder="Enter NAICS Code"
                        />
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="companyStatus"
                          className="form-label label-text"
                        >
                          Status
                        </label>
                        <select
                          id="companyStatus"
                          className="form-select addCompany-input"
                          defaultValue=""
                        >
                          <option value="" disabled>
                            Choose
                          </option>
                          {/* TODO: map real statuses */}
                          <option>Active</option>
                          <option>Inactive</option>
                          <option>Pending</option>
                        </select>
                      </div>

                      <div className="col-12">
                        <label
                          htmlFor="legalName"
                          className="form-label label-text"
                        >
                          Legal Name
                        </label>
                        <input
                          type="text"
                          id="legalName"
                          className="form-control addCompany-input"
                          placeholder="Enter Legal Name"
                        />
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              {/* Social/Other Section END */}

              {/* Submit Button (Optional) */}
              <div className="col-12 mt-4 text-end">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default AdminAddCompany;
